// assets
import {
  Activity,
  Devices,
  Hierarchy,
  HomeTrendUp,
  Map,
  // Message,
  NotificationStatus,
  Profile2User,
  Setting2,
  TaskSquare
} from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

const mineacs: NavItemType = {
  id: 'mineacs',
  title: 'MineACS',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: HomeTrendUp,
      breadcrumbs: false
    },
    // {
    //   id: 'mia',
    //   title: 'MIA Assistant',
    //   type: 'item',
    //   url: '/mia',
    //   icon: Message,
    //   breadcrumbs: false
    // },
    {
      id: 'live-map',
      title: 'Live Map',
      type: 'item',
      url: '/live-map',
      icon: Map,
      breadcrumbs: false
    },
    {
      id: 'telemetry',
      title: 'Telemetry',
      type: 'item',
      url: '/telemetry',
      icon: Activity,
      breadcrumbs: false
    },
    {
      id: 'events',
      title: 'Events',
      type: 'item',
      url: '/events',
      icon: NotificationStatus,
      breadcrumbs: false
    },
    {
      id: 'devices',
      title: 'Devices',
      type: 'item',
      url: '/devices',
      icon: Devices,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: Setting2,
      breadcrumbs: false
    },
    {
      id: 'geofences',
      title: 'Geofences',
      type: 'item',
      url: '/geofences',
      icon: Hierarchy,
      breadcrumbs: false
    },
    {
      id: 'drivers',
      title: 'Drivers',
      type: 'item',
      url: '/drivers',
      icon: Profile2User,
      breadcrumbs: false
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: TaskSquare,
      breadcrumbs: false
    }
  ]
};

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [mineacs]
};

export default menuItems;
